import React, { useState } from 'react'
import { Tabs } from 'antd'
import styled from 'styled-components/macro'
import { supplierPortalTheme } from 'src/branding/supplierPortalTheme'
import CommunicateTab from './CommunicateTab'
import SentMessagesTab from './SentMessagesTab'
import SentEmailsTab from './SentEmailsTab'

const { TabPane } = Tabs

const Marketing = () => {
  const [activeTab, setActiveTab] = useState('communicate')

  return (
    <MarketingWrapper>
      <StyledTabs activeKey={activeTab} onChange={setActiveTab}>
        <TabPane tab='Communicate' key='communicate'>
          <CommunicateTab />
        </TabPane>
        <TabPane tab='Sent Messages' key='sent-messages'>
          <SentMessagesTab />
        </TabPane>
        <TabPane tab='Sent Emails' key='sent-emails'>
          <SentEmailsTab />
        </TabPane>
      </StyledTabs>
    </MarketingWrapper>
  )
}

const MarketingWrapper = styled.div`
  --sp-color-bg: ${supplierPortalTheme.colors.bg};
  --sp-color-surface: ${supplierPortalTheme.colors.surface};
  --sp-color-text: ${supplierPortalTheme.colors.text};
  --sp-color-muted: ${supplierPortalTheme.colors.muted};
  --sp-color-primary: ${supplierPortalTheme.colors.primary};
  --sp-color-border: ${supplierPortalTheme.colors.border};
  --sp-radius-card: ${supplierPortalTheme.radii.card};
  --sp-shadow-card: ${supplierPortalTheme.shadows.card};
  --sp-space-xs: ${supplierPortalTheme.spacing.xs};
  --sp-space-sm: ${supplierPortalTheme.spacing.sm};
  --sp-space-md: ${supplierPortalTheme.spacing.md};
  --sp-space-lg: ${supplierPortalTheme.spacing.lg};
  --sp-space-xl: ${supplierPortalTheme.spacing.xl};
  --sp-space-xxl: ${supplierPortalTheme.spacing.xxl};
  width: 100%;
  min-height: calc(100vh - 200px);
  background: var(--sp-color-bg);
`

const StyledTabs = styled(Tabs)`
  && {
    .ant-tabs-nav {
      margin-bottom: var(--sp-space-lg);
      margin-top: 0;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;
      background: transparent;
      border-radius: 0;
      box-shadow: none;
      position: relative;
      overflow: visible;
    }

    .ant-tabs-nav::before {
      display: none;
    }

    .ant-tabs-nav-wrap {
      padding: 0;
      overflow: visible;
    }

    .ant-tabs-nav-list {
      padding: 0;
      overflow: visible;
    }

    .ant-tabs-tab {
      font-weight: 600;
      font-size: 15px;
      padding: var(--sp-space-md) var(--sp-space-lg);
      margin: 0 var(--sp-space-xs) 0 0;
      color: var(--sp-color-muted);
      border: none;
      line-height: 1.5;
      min-height: 44px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      overflow: visible;
    }

    .ant-tabs-tab-btn {
      line-height: 1.5;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }

    .ant-tabs-tab-active {
      color: var(--sp-color-primary);
    }

    .ant-tabs-ink-bar {
      bottom: 0;
    }

    .ant-tabs-content-holder {
      padding: 0;
      margin-top: var(--sp-space-lg);
    }
  }
`

export default Marketing
